<template>
  <div>
    <b-navbar-nav>
      <b-nav-item-dropdown
        class="dropdown-notification dropdown-no-scroll mr-25"
        menu-class="dropdown-menu-media rate-calculator-menu"
        right
        no-caret
        no-flip
        :popper-opts="calculatorPopperOpts"
        @shown="onCalculatorShown"
        @hidden="onCalculatorHidden"
      >
        <template #button-content>
          <div class="bg-circle">
            <img
              class="responsive-icon"
              size="21"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jYWxjdWxhdG9yIj48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMjAiIHg9IjQiIHk9IjIiIHJ4PSIyIi8+PGxpbmUgeDE9IjgiIHgyPSIxNiIgeTE9IjYiIHkyPSI2Ii8+PGxpbmUgeDE9IjE2IiB4Mj0iMTYiIHkxPSIxNCIgeTI9IjE4Ii8+PHBhdGggZD0iTTE2IDEwaC4wMSIvPjxwYXRoIGQ9Ik0xMiAxMGguMDEiLz48cGF0aCBkPSJNOCAxMGguMDEiLz48cGF0aCBkPSJNMTIgMTRoLjAxIi8+PHBhdGggZD0iTTggMTRoLjAxIi8+PHBhdGggZD0iTTEyIDE4aC4wMSIvPjxwYXRoIGQ9Ik04IDE4aC4wMSIvPjwvc3ZnPg=="
              @click="handleButtonClick"
            >
          </div>
        </template>
        <!-- Header -->
        <div class="my-container">
          <li class="dropdown-menu-header">
            <div class="dropdown-header d-flex justify-content-center">
              <h4 class="calculator-title mb-0">
                Rate Calculator
              </h4>
            </div>
          </li>
          <li>
            <!-- Origin City -->
            <b-col cols="12">
              <b-form-group
                label=" Origin City"
                label-for="h-originCity"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-originCity"
                  vid="h-c-originCity"
                  rules="required"
                >
                  <v-select
                    v-model="origin_city_id"
                    :options="cityOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select City"
                    autocomplete="nope"
                    @change="getCalculateDeliveryCharge"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </li>
          <li>
            <b-col cols="12">
              <!-- Destination City -->
              <b-form-group
                label="Destination City"
                label-for="city"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-city"
                  vid="h-c-city"
                  rules="required"
                >
                  <v-select
                    v-model="form.destination_city_id"
                    :options="cityOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select City"
                    autocomplete="nope"
                    @change="getCalculateDeliveryCharge"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </li>
          <li v-if="serviceTypeFeatureEnabled">
            <b-col cols="12">
              <b-form-group
                label="Service Type"
                label-for="serviceType"
              >
                <v-select
                  v-model="service_type_id"
                  class="calculator-service-type"
                  :options="serviceTypeOptions"
                  :reduce="option => option.id"
                  label="name"
                  placeholder="Select Service Type"
                  autocomplete="nope"
                  @input="onServiceTypeChange"
                />
              </b-form-group>
            </b-col>
          </li>
          <li>
            <b-col cols="12">

              <!-- Weight -->
              <b-form-group
                label="Weight"
                label-for="weight"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-weight"
                  vid="h-c-weight"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="weight"
                      v-model="form.weight"
                      type="number"
                      placeholder="1"
                      autocomplete="off"
                      step="0.01"
                      @change="getCalculateDeliveryCharge"
                    />
                    <b-input-group-append is-text>
                      <b>Kg</b>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </li>
          <li>
            <b-col cols="12">
              <!-- Delivery charge -->
              <b-form-group
                label="Delivery Charge"
                label-for="delivery_charge"
              >
                <strong><input
                  id="delivery_charge"
                  v-model="delivery_charge"
                  type="text"
                  class="form-control"
                  disabled
                  autocomplete="off"
                ></strong>
              </b-form-group>
            </b-col>
          </li>
        </div>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BNavItemDropdown, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BNavbarNav,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
// eslint-disable-next-line import/extensions
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import { isServiceTypeRateCardFeatureEnabled } from '@/helpers/serviceTypeFeature'

const ResourceRepository = RepositoryFactory.get('resource')
const CalculatorRepository = RepositoryFactory.get('calculator')
const MerchantRepository = RepositoryFactory.get('merchant')
const ServiceTypeRepository = RepositoryFactory.get('serviceType')
const OrderSettingsRepository = RepositoryFactory.get('orderSetting')
export default {
  components: {
    BNavItemDropdown,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    vSelect,
    BNavbarNav,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      originCities: [],
      destinationCities: [],
      cityOptions: [],
      origin_city_id: '',
      destination_city_id: '',
      form: {},
      weight: '',
      merchant_id: 0,
      delivery_charge: '',
      service_type_id: null,
      serviceTypeOptions: [],
      orderSettings: {},
      modules: [],
      calculatorPopperOpts: {
        modifiers: {
          flip: { enabled: false },
          preventOverflow: {
            priority: ['right', 'left'],
          },
        },
      },
    }
  },
  computed: {
    serviceTypeFeatureEnabled() {
      return isServiceTypeRateCardFeatureEnabled(this.modules, this.orderSettings)
    },
  },
  async mounted() {
    await this.loadServiceTypeFeature()
  },
  methods: {
    async handleButtonClick() {
      await this.getCityList()
      await this.getMerchantBusinessSettingsDetails()
      await this.loadServiceTypeFeature()
    },
    async loadServiceTypeFeature() {
      await this.readOrderSetting()
      await this.readModules()
      if (this.serviceTypeFeatureEnabled) {
        await this.fetchServiceTypes()
      }
    },
    async readModules() {
      try {
        const cached = localStorage.getItem('module_data')
        const data = cached
          ? JSON.parse(cached)
          : (await ResourceRepository.getModules()).data.data
        if (!cached && data) localStorage.setItem('module_data', JSON.stringify(data))
        this.modules = Array.isArray(data) ? data : []
      } catch (e) {
        this.modules = []
      }
    },
    async getCityList() {
      try {
        this.cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityDropdownListMultilingual()).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.cityOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getMerchantBusinessSettingsDetails() {
      try {
        const data = localStorage.getItem('merchant_business_setting') ? JSON.parse(localStorage.getItem('merchant_business_setting')) : (await MerchantRepository.getMerchantBusinessSettingsDetails()).data.data
        if (!localStorage.getItem('merchant_business_setting')) localStorage.setItem('merchant_business_setting', JSON.stringify(data))
        this.merchant_id = data.merchant_id
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readOrderSetting() {
      try {
        let settings = localStorage.getItem('order_setting')
          ? JSON.parse(localStorage.getItem('order_setting'))
          : null
        if (!settings || settings.service_type_rate_card === undefined) {
          settings = (await OrderSettingsRepository.getOrderSettingsResource()).data.data
          localStorage.setItem('order_setting', JSON.stringify(settings))
        }
        this.orderSettings = settings || {}
      } catch (e) {
        this.orderSettings = {}
      }
    },
    async fetchServiceTypes() {
      try {
        const { data } = await ServiceTypeRepository.getServiceTypeDropdown()
        this.serviceTypeOptions = data.data || []
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    onCalculatorShown() {
      this.$root.$emit('rate-calculator-open', true)
      this.loadServiceTypeFeature()
    },
    onCalculatorHidden() {
      this.$root.$emit('rate-calculator-open', false)
    },
    onServiceTypeChange(value) {
      this.service_type_id = value
      this.getCalculateDeliveryCharge()
    },
    async getCalculateDeliveryCharge() {
      const { weight } = this.form
      if (!this.origin_city_id || !this.form.destination_city_id || weight === '' || weight === null || weight === undefined) {
        return
      }
      try {
        this.loading = true
        const payload = {
          origin_city_id: this.origin_city_id,
          destination_city_id: this.form.destination_city_id,
          weight: this.form.weight,
          merchant_id: this.merchant_id,
          service_type_id: this.serviceTypeFeatureEnabled ? (this.service_type_id || null) : null,
        }
        const { data } = await CalculatorRepository.getCalculateDeliveryCharge(payload)
        this.delivery_charge = data['delivery charge']
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style>
.my-container {
  margin: 20px;
  padding: 10px;
}
.calculator-service-type.vs--single .vs__dropdown-toggle {
  padding-left: 2px !important;
  padding-right: 0 !important;
}
.calculator-service-type .vs__selected-options {
  max-width: 100% !important;
}
.calculator-service-type .vs__search {
  padding-right: 0 !important;
  padding-left: 2px !important;
}
.calculator-service-type.vs--single:not(.vs--open) .vs__selected-options:has(.vs__selected) {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  max-width: calc(100% - 1.6rem) !important;
  overflow: hidden !important;
}
.calculator-service-type.vs--single:not(.vs--open) .vs__selected {
  display: block !important;
  position: static !important;
  flex: 1 1 auto !important;
  width: auto !important;
  max-width: none !important;
  margin: 0 !important;
  overflow: hidden !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}
.calculator-service-type.vs--single:not(.vs--open) .vs__selected + .vs__search {
  position: absolute !important;
  width: 0 !important;
  height: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  border: 0 !important;
  flex: 0 0 0 !important;
  opacity: 0 !important;
}
.calculator-service-type .vs__search::placeholder {
  text-overflow: clip;
}
.responsive-icon {
    width: 22px;
    height: 22px;
    color: white;
}
.bg-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--primary);
  cursor: pointer;
  overflow: hidden; /* Ensure no extra content displays */
  margin: 0; /* Ensure no margin is causing issues */
  padding: 0; /* Ensure no padding is causing issues */
  position: relative; /* For positioning if needed */
}

.responsive-icon {
  display: block; /* Change to block to remove any inline space */
  width: 21px;
  height: 21px;
  color: white; /* Icon color */
  margin: 0; /* Remove any default margin */
  padding: 0; /* Remove any default padding */
  position: relative; /* Ensures the icon is positioned correctly */
  top: 0; /* Reset any vertical position */
}
@media (max-width: 768px) {
  .responsive-icon {
    width: 12px;
    height: 12px;
  }
}
</style>
